import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e9e8d68"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "center",
  autoplay: "",
  muted: "",
  loop: "",
  controls: ""
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.promotionalVideoExists && !$setup.hideVideo)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["video-card", { 'video-card-mobile': $setup.type != 'lg' }])
      }, [
        ($setup.type != 'lg')
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "material-icons close-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.hideVideo = true))
            }, " close "))
          : _createCommentVNode("", true),
        _createElementVNode("video", _hoisted_1, [
          _createElementVNode("source", { src: $setup.linkVideo }, null, 8, _hoisted_2),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("promotionVideo.supportError")), 1)
        ])
      ], 2))
    : _createCommentVNode("", true)
}